let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("24hV7")).then(() => parcelRequire('lovmf'));